import * as Yup from 'yup';
import { emailValidation, stringValidation, zipValidation } from 'src/services/validation';
const businessInfoSchema = Yup.object().shape({
  busName: stringValidation(),
  emailAddr: emailValidation(),
  natureOfBus: stringValidation(),
  ownershipType: stringValidation(),
  homebiz: stringValidation(),
  dateOpenedLoc: stringValidation(),
  naicsCode: stringValidation(),
  mailAddr: Yup.string().when('sameForMail', {
    is: false,
    then: Yup.string().required('Required'),
  }),
  mailCity: Yup.string().when('sameForMail', {
    is: false,
    then: Yup.string().required('Required'),
  }),
  mailZip: Yup.string().when('sameForMail', {
    is: false,
    then: zipValidation(),
  }),
  busLoc: stringValidation(),
  busCity: stringValidation(),
  busZip: zipValidation(),
  dbaName: stringValidation(),
  contactAgreement: Yup.boolean().oneOf([true], 'Required').required('Required'),
});

export default businessInfoSchema;
